<template>
  <div class="index container">

    <transition name="fade">
      <router-view @showParent="showParent">
      </router-view>
    </transition>

    <div v-if="showParentPage">

      <v-card elevation="0" outlined class="mt-5">

        <v-sheet class="pa-4 d-md-flex">

          <v-sheet class="flex-sm-column">
            <p class="text-h4 ma-0">Terminologies</p>
          </v-sheet>

          <v-sheet class="flex-sm-column my-3 my-md-0">
            <v-breadcrumbs class="pa-md-3 pa-0">
              <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }">Home</v-breadcrumbs-item>
              <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
              <v-breadcrumbs-item :exact="true" :to="{ name: 'accountTerminology', params: {} }" active>
                Account Terminology
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-sheet>

          <v-spacer></v-spacer>

          <v-sheet class="flex-sm-column">
            <v-row>
              <v-col cols="12">
                <v-btn class="align-self-end align-self-lg-start text-capitalize" color="primary" block text outlined
                  :to="{ name: 'accountTerminologyCreate', params: {} }">
                  <v-icon>mdi-plus</v-icon>
                  Add Terminology
                </v-btn>
              </v-col>

            </v-row>

          </v-sheet>

        </v-sheet>
      </v-card>

      <v-card elevation="0" class="mt-5">
        <v-card-text class="pa-10">
          <terminology-table :account.sync="account" :isBlockButton="false"></terminology-table>

        </v-card-text>

      </v-card>
    </div>
    <confirmation-dialog ref="confirm" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const ConfirmationDialog = () =>
  import("@/components/common/ConfirmationDialog.vue");
const TerminologyTable = () => import("@/components/account/terminologyTableForm.vue");


export default {
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 100
      },
      accountTerminologyList: [],
      showParentPage: true,
      headers: [
        {
          text: "Name",
          value: "name",
          align: "start",
          sortable: true
        },
        {
          text: "Value",
          value: "value",
          align: "start",
          sortable: false
        },

        { text: "Actions", value: "actions", align: "end", sortable: false }
      ],
      sort: {
        key: null
      },
      searchTerms: '',
      account: [],
    }
  },
  components: {
    ConfirmationDialog,
    TerminologyTable
  },
  computed: {
    ...mapGetters("accountTerminology", ["accountTerminologyProcessed", "getAccountTerminologies"]),
    ...mapGetters("navigation", ["globalCenter"]),

  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage"
    ]),
    ...mapActions("accountTerminology", ["deleteAccountTerminology", "fetchAccountTerminologies"]),
    getResources() {
      const params = {
        page: this.pagination.pageIndex && this.pagination.pageIndex > 0 ? this.pagination.pageIndex - 1 : 0,
        size: this.pagination.pageSize,
        name: this.searchTerms,
        value: this.searchTerms
      };
      this.fetchAccountTerminologies(params)
        .then(response => {
          if (response) {
            this.pagination.totalSize = response.totalElements;
            this.accountTerminologyList = response.content;
          }
        })
        .catch(error => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    async initAccount() {
      return await this.$axios
        .get("/account/get-by-id", {
          params: { accountId: this.globalCenter.accountId },
        })
        .then((resp) => {
          return resp.data;

        })
        .catch(() => {
          this.addErrorMessage("Error loading account from server");
        });
    },
  },
  mounted() {
    this.initAccount().then((account) => {
      this.account = account;
    })
  },
  watch: {
    'pagination.numberRegisterForPage': function () {
      this.pagination.current = -1;
    },
  },
  beforeRouteUpdate(to, from, next) {
    const toDepth = to.path.split("/").length;
    const fromDepth = from.path.split("/").length;
    this.showParentPage = toDepth < fromDepth;
    if (this.showParentPage) {
      this.getResources();
    }
    next();
  },

}
</script>

    